export const EEmail = {
    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    minLength: 3,
    maxLength: 200,
};

export const EName = {
    minLength: 3,
    maxLength: 200,
};

export const ELastName = {
    minLength: 3,
    maxLength: 200,
};

export const EPassword = {
    minLength: 6,
    maxLength: 200,
};

export const EPosition = {
    minLength: 3,
    maxLength: 200,
};

export const EQuestion = {
    minLength: 3,
    maxLength: 1000,
    message: {
        required: 'El campo es requerido.',
        minLength: 'Min. 3 caracteres.',
        maxLength: 'Superó el Max. de caracteres.',
        error: {
            inputSave:
                'Vuelve a ingresar tu respuesta. Ocurrio un error inesperado.',
            selectSave:
                'Vuelve a elegir tu respuesta. Ocurrio un error inesperado.',
        },
    },
};

export const EPhone = {
    pattern: /^\d+$/,
    minLength: 7,
    maxLength: 9,
};

export const ESelectCustom = {
    control: (provided: any) => ({
        ...provided,
        height: 50,
        boxShadow: 'none',
        cursor: 'pointer',
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: '2px 18px',
        height: '42px',
        overflowY: 'auto',
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        color: '#4959b1',
    }),
};

export const EErrorMsg = {
    generic: 'Vuelve a intentarlo. Ocurrio un error inesperado.',
    confirmPassword: 'Las contraseñas ingresadas deben ser iguales.',
    dataForm: 'Verifique los datos ingresados.',
};

export const ESuccessMsg = {
    mailSend: 'Email enviado. Revisa tu bandeja de entrada.',
    saved: 'Tu avance ha sido guardado',
    profile: 'Tu perfil se actualizo correctamente.',
    snackBar: 'Tu archivo cargó correctamente.',
};

export const ESelectTheme = (theme: any) => ({
    ...theme,
    borderRadius: 3,
    colors: {
        ...theme.colors,
        primary: '#4959b1',
        danger: '#ea4335',
        primary75: '#f5f5fa',
        primary50: '#f5f5fa',
        primary25: '#f5f5fa',
        neutral80: '#515151',
    },
});

export const ESelectCustomPrimary = {
    control: (provided: any) => ({
        ...provided,
        height: 50,
        boxShadow: 'none',
        cursor: 'pointer',
        backgroundColor: '#4959b1',
        color: 'white',
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: '2px 18px',
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        color: 'white',
    }),
    placeholder: (provided: any) => ({
        ...provided,
        color: 'white',
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: 'white',
    }),
};

export const ESelectThemePrimary = (theme: any) => ({
    ...theme,
    borderRadius: 3,
    colors: {
        ...theme.colors,
        primary: '#4959b1',
        danger: '#ea4335',
        primary75: '#f5f5fa',
        primary50: '#f5f5fa',
        primary25: '#f5f5fa',
        neutral80: '#515151',
    },
});
